import { useAuthStore } from "@/store/auth";
export function permissionCheck(permission){
    const authstore = useAuthStore()
    let access = false
    if(typeof permission == 'string'){
        access = authstore.prvi?.includes(permission)
        
    }else if(Array.isArray(permission) && typeof permission != 'string'){
       access = permission.some(perm => authstore.prvi?.include(perm))
    }else {
        access = false
    }
    return access
}